// GENERATED by scripts/refresh-pricing.mjs from https://openrouter.ai/api/v1/models
// on 2026-10-14. Do not edit by hand — re-run the script. USD per million tokens.
/* eslint-disable */

export const OPENROUTER_PRICING_AS_OF = "2026-10-14";

export interface GeneratedPricing {
  inputPerMtoken: number;
  outputPerMtoken: number;
}

export const OPENROUTER_PRICING: {
  anthropic: Record<string, GeneratedPricing>;
  openai: Record<string, GeneratedPricing>;
  openrouter: Record<string, GeneratedPricing>;
} = {
  anthropic: {
    "claude-fable-5": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "claude-fable-5-1": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "claude-haiku-4-5": { inputPerMtoken: 1, outputPerMtoken: 5 },
    "claude-haiku-5-5": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "claude-opus-4-1": { inputPerMtoken: 15, outputPerMtoken: 75 },
    "claude-opus-4-5": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4-6": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4-7": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4-8": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-5": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-5-5": { inputPerMtoken: 4, outputPerMtoken: 20 },
    "claude-sonnet-4": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-4-5": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-4-6": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-5": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "claude-sonnet-5-5": { inputPerMtoken: 2, outputPerMtoken: 10 },
  },
  openai: {
    "gpt-3.5-turbo": { inputPerMtoken: 0.5, outputPerMtoken: 1.5 },
    "gpt-3.5-turbo-0613": { inputPerMtoken: 1, outputPerMtoken: 2 },
    "gpt-3.5-turbo-16k": { inputPerMtoken: 3, outputPerMtoken: 4 },
    "gpt-3.5-turbo-instruct": { inputPerMtoken: 1.5, outputPerMtoken: 2 },
    "gpt-4": { inputPerMtoken: 30, outputPerMtoken: 60 },
    "gpt-4-turbo": { inputPerMtoken: 10, outputPerMtoken: 30 },
    "gpt-4.1": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "gpt-4.1-mini": { inputPerMtoken: 0.4, outputPerMtoken: 1.6 },
    "gpt-4.1-nano": { inputPerMtoken: 0.1, outputPerMtoken: 0.4 },
    "gpt-4o": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-2024-05-13": { inputPerMtoken: 5, outputPerMtoken: 15 },
    "gpt-4o-2024-08-06": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-2024-11-20": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-mini": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "gpt-4o-mini-2024-07-18": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "gpt-5": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5-image": { inputPerMtoken: 10, outputPerMtoken: 10 },
    "gpt-5-image-mini": { inputPerMtoken: 2.5, outputPerMtoken: 2 },
    "gpt-5-mini": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "gpt-5-nano": { inputPerMtoken: 0.05, outputPerMtoken: 0.4 },
    "gpt-5-pro": { inputPerMtoken: 15, outputPerMtoken: 120 },
    "gpt-5.1": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex-max": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex-mini": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "gpt-5.2": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-chat": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-codex": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-pro": { inputPerMtoken: 21, outputPerMtoken: 168 },
    "gpt-5.3-codex": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.4": { inputPerMtoken: 2.5, outputPerMtoken: 15 },
    "gpt-5.4-image-2": { inputPerMtoken: 8, outputPerMtoken: 15 },
    "gpt-5.4-mini": { inputPerMtoken: 0.75, outputPerMtoken: 4.5 },
    "gpt-5.4-nano": { inputPerMtoken: 0.2, outputPerMtoken: 1.25 },
    "gpt-5.4-pro": { inputPerMtoken: 30, outputPerMtoken: 180 },
    "gpt-5.5": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "gpt-5.5-pro": { inputPerMtoken: 30, outputPerMtoken: 180 },
    "gpt-5.6-luna": { inputPerMtoken: 0.2, outputPerMtoken: 1.2 },
    "gpt-5.6-luna-pro": { inputPerMtoken: 0.2, outputPerMtoken: 1.2 },
    "gpt-5.6-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-5.6-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-5.6-terra": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gpt-5.6-terra-pro": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gpt-6-astra": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "gpt-6-astra-pro": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "gpt-6-luna": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "gpt-6-luna-pro": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "gpt-6-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6.1-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6.1-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-audio": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-audio-mini": { inputPerMtoken: 0.6, outputPerMtoken: 2.4 },
    "gpt-chat-latest": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "gpt-oss-120b": { inputPerMtoken: 0.037, outputPerMtoken: 0.17 },
    "gpt-oss-20b": { inputPerMtoken: 0.018, outputPerMtoken: 0.09 },
    "gpt-oss-safeguard-20b": { inputPerMtoken: 0.075, outputPerMtoken: 0.3 },
    "o1": { inputPerMtoken: 15, outputPerMtoken: 60 },
    "o1-pro": { inputPerMtoken: 150, outputPerMtoken: 600 },
    "o3": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "o3-mini": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o3-mini-high": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o3-pro": { inputPerMtoken: 20, outputPerMtoken: 80 },
    "o4-mini": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o4-mini-high": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
  },
  openrouter: {
    "aion-2.0": { inputPerMtoken: 0.8, outputPerMtoken: 1.6 },
    "aion-3.0": { inputPerMtoken: 3, outputPerMtoken: 6 },
    "aion-3.0-mini": { inputPerMtoken: 0.7, outputPerMtoken: 1.4 },
    "aion-3.5": { inputPerMtoken: 3, outputPerMtoken: 6 },
    "aion-3.5-mini": { inputPerMtoken: 0.7, outputPerMtoken: 1.4 },
    "aion-rp-llama-3.1-8b": { inputPerMtoken: 0.8, outputPerMtoken: 1.6 },
    "claude-fable-5": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "claude-fable-5.1": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "claude-fable-latest": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "claude-haiku-4.5": { inputPerMtoken: 1, outputPerMtoken: 5 },
    "claude-haiku-5.5": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "claude-haiku-latest": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "claude-opus-4.1": { inputPerMtoken: 15, outputPerMtoken: 75 },
    "claude-opus-4.5": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4.6": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4.7": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-4.8": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-5": { inputPerMtoken: 5, outputPerMtoken: 25 },
    "claude-opus-5.5": { inputPerMtoken: 4, outputPerMtoken: 20 },
    "claude-opus-latest": { inputPerMtoken: 4, outputPerMtoken: 20 },
    "claude-sonnet-4": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-4.5": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-4.6": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "claude-sonnet-5": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "claude-sonnet-5.5": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "claude-sonnet-latest": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "codestral-2508": { inputPerMtoken: 0.3, outputPerMtoken: 0.9 },
    "command-a": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "command-a-plus": { inputPerMtoken: 0.3, outputPerMtoken: 1.5 },
    "command-r-08-2024": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "command-r-plus-08-2024": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "command-r7b-12-2024": { inputPerMtoken: 0.0375, outputPerMtoken: 0.15 },
    "cydonia-24b-v4.1": { inputPerMtoken: 0.3, outputPerMtoken: 0.5 },
    "deepseek-chat": { inputPerMtoken: 0.32, outputPerMtoken: 0.89 },
    "deepseek-chat-v3-0324": { inputPerMtoken: 0.29, outputPerMtoken: 1.14 },
    "deepseek-chat-v3.1": { inputPerMtoken: 0.25, outputPerMtoken: 0.95 },
    "deepseek-flash-latest": { inputPerMtoken: 0.02016, outputPerMtoken: 0.891 },
    "deepseek-pro-latest": { inputPerMtoken: 0.1461, outputPerMtoken: 8 },
    "deepseek-r1": { inputPerMtoken: 0.7, outputPerMtoken: 2.5 },
    "deepseek-r1-0528": { inputPerMtoken: 0.5, outputPerMtoken: 2.15 },
    "deepseek-v3.1-terminus": { inputPerMtoken: 0.27, outputPerMtoken: 1 },
    "deepseek-v3.2": { inputPerMtoken: 0.259, outputPerMtoken: 0.8 },
    "deepseek-v3.2-exp": { inputPerMtoken: 0.27, outputPerMtoken: 0.41 },
    "deepseek-v4-flash": { inputPerMtoken: 0.091, outputPerMtoken: 0.182 },
    "deepseek-v4-flash-0731": { inputPerMtoken: 0.016, outputPerMtoken: 0.64 },
    "deepseek-v4-flash-latest": { inputPerMtoken: 0.0144, outputPerMtoken: 0.576 },
    "deepseek-v4-flash-vision-exp": { inputPerMtoken: 0.2156, outputPerMtoken: 0.6468 },
    "deepseek-v4-pro": { inputPerMtoken: 0.430824, outputPerMtoken: 0.861648 },
    "deepseek-v4-pro-0813": { inputPerMtoken: 0.66, outputPerMtoken: 1.98 },
    "deepseek-v4.1-flash": { inputPerMtoken: 0.02016, outputPerMtoken: 0.891 },
    "devstral-2512": { inputPerMtoken: 0.4, outputPerMtoken: 2 },
    "dolphin-mistral-24b-venice-edition": { inputPerMtoken: 0.2, outputPerMtoken: 0.9 },
    "dots-3-note-preview:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "ember-1": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "extract": { inputPerMtoken: 0.04, outputPerMtoken: 0 },
    "free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "fugu-max": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "fugu-ultra": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "fugu-ultra-v2": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "gemini-2.5-flash": { inputPerMtoken: 0.3, outputPerMtoken: 2.5 },
    "gemini-2.5-flash-image": { inputPerMtoken: 0.3, outputPerMtoken: 2.5 },
    "gemini-2.5-flash-lite": { inputPerMtoken: 0.1, outputPerMtoken: 0.4 },
    "gemini-2.5-pro": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gemini-2.5-pro-preview": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gemini-3-flash-preview": { inputPerMtoken: 0.5, outputPerMtoken: 3 },
    "gemini-3-pro-image": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gemini-3-pro-image-preview": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gemini-3.1-flash-image": { inputPerMtoken: 0.5, outputPerMtoken: 3 },
    "gemini-3.1-flash-image-preview": { inputPerMtoken: 0.5, outputPerMtoken: 3 },
    "gemini-3.1-flash-lite": { inputPerMtoken: 0.25, outputPerMtoken: 1.5 },
    "gemini-3.1-flash-lite-image": { inputPerMtoken: 0.25, outputPerMtoken: 1.5 },
    "gemini-3.1-flash-lite-preview": { inputPerMtoken: 0.25, outputPerMtoken: 1.5 },
    "gemini-3.1-pro-preview": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gemini-3.1-pro-preview-customtools": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gemini-3.5-flash": { inputPerMtoken: 1.5, outputPerMtoken: 9 },
    "gemini-3.5-flash-lite": { inputPerMtoken: 0.3, outputPerMtoken: 2.5 },
    "gemini-3.6-flash": { inputPerMtoken: 0.75, outputPerMtoken: 3.75 },
    "gemini-3.7-flash": { inputPerMtoken: 0.75, outputPerMtoken: 3.75 },
    "gemini-3.8-flash": { inputPerMtoken: 0.75, outputPerMtoken: 3.75 },
    "gemini-4-argon": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gemini-flash-latest": { inputPerMtoken: 0.75, outputPerMtoken: 3.75 },
    "gemini-nano-banana-2.1": { inputPerMtoken: 1.5, outputPerMtoken: 7.5 },
    "gemini-pro-latest": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gemma-2-27b-it": { inputPerMtoken: 0.65, outputPerMtoken: 0.65 },
    "gemma-3-12b-it": { inputPerMtoken: 0.05, outputPerMtoken: 0.15 },
    "gemma-3-27b-it": { inputPerMtoken: 0.08, outputPerMtoken: 0.45 },
    "gemma-3-4b-it": { inputPerMtoken: 0.05, outputPerMtoken: 0.1 },
    "gemma-4-26b-a4b-it": { inputPerMtoken: 0.09, outputPerMtoken: 0.3 },
    "gemma-4-26b-a4b-it:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "gemma-4-31b-it": { inputPerMtoken: 0.09, outputPerMtoken: 0.34 },
    "gemma-4-31b-it:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "glm-4.5": { inputPerMtoken: 0.6, outputPerMtoken: 2.2 },
    "glm-4.5-air": { inputPerMtoken: 0.13, outputPerMtoken: 0.85 },
    "glm-4.5v": { inputPerMtoken: 0.6, outputPerMtoken: 1.8 },
    "glm-4.6": { inputPerMtoken: 0.5, outputPerMtoken: 2 },
    "glm-4.6v": { inputPerMtoken: 0.3, outputPerMtoken: 0.9 },
    "glm-4.7": { inputPerMtoken: 0.6, outputPerMtoken: 2.2 },
    "glm-4.7-flash": { inputPerMtoken: 0.0605, outputPerMtoken: 0.4 },
    "glm-5": { inputPerMtoken: 0.6, outputPerMtoken: 1.92 },
    "glm-5-turbo": { inputPerMtoken: 1.2, outputPerMtoken: 4 },
    "glm-5.1": { inputPerMtoken: 1.33, outputPerMtoken: 4.18 },
    "glm-5.2": { inputPerMtoken: 0.05, outputPerMtoken: 7 },
    "glm-5.3": { inputPerMtoken: 0.079, outputPerMtoken: 4.8 },
    "glm-5.3-flash": { inputPerMtoken: 0.036, outputPerMtoken: 0.9 },
    "glm-5.3-flashx": { inputPerMtoken: 0.37, outputPerMtoken: 1.25 },
    "glm-5.3-prime": { inputPerMtoken: 2.8, outputPerMtoken: 8.8 },
    "glm-5v-turbo": { inputPerMtoken: 1.2, outputPerMtoken: 4 },
    "glm-flash-latest": { inputPerMtoken: 0.036, outputPerMtoken: 0.9 },
    "glm-latest": { inputPerMtoken: 0.0576, outputPerMtoken: 4.4 },
    "gpt-3.5-turbo": { inputPerMtoken: 0.5, outputPerMtoken: 1.5 },
    "gpt-3.5-turbo-0613": { inputPerMtoken: 1, outputPerMtoken: 2 },
    "gpt-3.5-turbo-16k": { inputPerMtoken: 3, outputPerMtoken: 4 },
    "gpt-3.5-turbo-instruct": { inputPerMtoken: 1.5, outputPerMtoken: 2 },
    "gpt-4": { inputPerMtoken: 30, outputPerMtoken: 60 },
    "gpt-4-turbo": { inputPerMtoken: 10, outputPerMtoken: 30 },
    "gpt-4.1": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "gpt-4.1-mini": { inputPerMtoken: 0.4, outputPerMtoken: 1.6 },
    "gpt-4.1-nano": { inputPerMtoken: 0.1, outputPerMtoken: 0.4 },
    "gpt-4o": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-2024-05-13": { inputPerMtoken: 5, outputPerMtoken: 15 },
    "gpt-4o-2024-08-06": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-2024-11-20": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-4o-mini": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "gpt-4o-mini-2024-07-18": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "gpt-5": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5-image": { inputPerMtoken: 10, outputPerMtoken: 10 },
    "gpt-5-image-mini": { inputPerMtoken: 2.5, outputPerMtoken: 2 },
    "gpt-5-mini": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "gpt-5-nano": { inputPerMtoken: 0.05, outputPerMtoken: 0.4 },
    "gpt-5-pro": { inputPerMtoken: 15, outputPerMtoken: 120 },
    "gpt-5.1": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex-max": { inputPerMtoken: 1.25, outputPerMtoken: 10 },
    "gpt-5.1-codex-mini": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "gpt-5.2": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-chat": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-codex": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.2-pro": { inputPerMtoken: 21, outputPerMtoken: 168 },
    "gpt-5.3-codex": { inputPerMtoken: 1.75, outputPerMtoken: 14 },
    "gpt-5.4": { inputPerMtoken: 2.5, outputPerMtoken: 15 },
    "gpt-5.4-image-2": { inputPerMtoken: 8, outputPerMtoken: 15 },
    "gpt-5.4-mini": { inputPerMtoken: 0.75, outputPerMtoken: 4.5 },
    "gpt-5.4-nano": { inputPerMtoken: 0.2, outputPerMtoken: 1.25 },
    "gpt-5.4-pro": { inputPerMtoken: 30, outputPerMtoken: 180 },
    "gpt-5.5": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "gpt-5.5-pro": { inputPerMtoken: 30, outputPerMtoken: 180 },
    "gpt-5.6-luna": { inputPerMtoken: 0.2, outputPerMtoken: 1.2 },
    "gpt-5.6-luna-pro": { inputPerMtoken: 0.2, outputPerMtoken: 1.2 },
    "gpt-5.6-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-5.6-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-5.6-terra": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gpt-5.6-terra-pro": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "gpt-6-astra": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "gpt-6-astra-pro": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "gpt-6-luna": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "gpt-6-luna-pro": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "gpt-6-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6.1-sol": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-6.1-sol-pro": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-astra-latest": { inputPerMtoken: 10, outputPerMtoken: 50 },
    "gpt-audio": { inputPerMtoken: 2.5, outputPerMtoken: 10 },
    "gpt-audio-mini": { inputPerMtoken: 0.6, outputPerMtoken: 2.4 },
    "gpt-chat-latest": { inputPerMtoken: 5, outputPerMtoken: 30 },
    "gpt-luna-latest": { inputPerMtoken: 0.1, outputPerMtoken: 0.5 },
    "gpt-mini-latest": { inputPerMtoken: 0.75, outputPerMtoken: 4.5 },
    "gpt-oss-120b": { inputPerMtoken: 0.037, outputPerMtoken: 0.17 },
    "gpt-oss-20b": { inputPerMtoken: 0.018, outputPerMtoken: 0.09 },
    "gpt-oss-safeguard-20b": { inputPerMtoken: 0.075, outputPerMtoken: 0.3 },
    "gpt-sol-latest": { inputPerMtoken: 2, outputPerMtoken: 10 },
    "gpt-terra-latest": { inputPerMtoken: 2, outputPerMtoken: 12 },
    "granite-4.0-h-micro": { inputPerMtoken: 0.017, outputPerMtoken: 0.112 },
    "granite-4.2-8b": { inputPerMtoken: 0.06, outputPerMtoken: 0.25 },
    "grok-4.20": { inputPerMtoken: 1.25, outputPerMtoken: 2.5 },
    "grok-4.20-multi-agent": { inputPerMtoken: 1.25, outputPerMtoken: 2.5 },
    "grok-4.3": { inputPerMtoken: 1.25, outputPerMtoken: 2.5 },
    "grok-4.5": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "grok-4.6": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "grok-4.7": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "grok-build-0.1": { inputPerMtoken: 1, outputPerMtoken: 2 },
    "grok-latest": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "hermes-3-llama-3.1-405b": { inputPerMtoken: 1, outputPerMtoken: 1 },
    "hermes-3-llama-3.1-70b": { inputPerMtoken: 0.7, outputPerMtoken: 0.7 },
    "hermes-4-405b": { inputPerMtoken: 1, outputPerMtoken: 3 },
    "hunyuan-a13b-instruct": { inputPerMtoken: 0.14, outputPerMtoken: 0.57 },
    "hy-mt2-1.8b": { inputPerMtoken: 0.044, outputPerMtoken: 0.177 },
    "hy-mt2-30b-a3b": { inputPerMtoken: 0.074, outputPerMtoken: 0.295 },
    "hy-mt2-7b": { inputPerMtoken: 0.074, outputPerMtoken: 0.295 },
    "hy3": { inputPerMtoken: 0.132, outputPerMtoken: 0.528 },
    "hy3-preview": { inputPerMtoken: 0.18, outputPerMtoken: 0.6 },
    "hy4-preview": { inputPerMtoken: 0.834, outputPerMtoken: 2.501 },
    "inkling": { inputPerMtoken: 1, outputPerMtoken: 4.05 },
    "inkling-small": { inputPerMtoken: 0.45, outputPerMtoken: 1.2 },
    "inkling-small:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "inkling:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "kimi-k2": { inputPerMtoken: 0.57, outputPerMtoken: 2.3 },
    "kimi-k2-0905": { inputPerMtoken: 0.6, outputPerMtoken: 2.5 },
    "kimi-k2-thinking": { inputPerMtoken: 0.6, outputPerMtoken: 2.5 },
    "kimi-k2.5": { inputPerMtoken: 0.5, outputPerMtoken: 2.5 },
    "kimi-k2.6": { inputPerMtoken: 0.65, outputPerMtoken: 3.41 },
    "kimi-k2.7-code": { inputPerMtoken: 0.6712, outputPerMtoken: 3.35 },
    "kimi-k3": { inputPerMtoken: 0.7, outputPerMtoken: 15 },
    "kimi-latest": { inputPerMtoken: 0.536, outputPerMtoken: 14 },
    "l3-lunaris-8b": { inputPerMtoken: 0.04, outputPerMtoken: 0.05 },
    "l3.1-euryale-70b": { inputPerMtoken: 0.85, outputPerMtoken: 0.85 },
    "l3.3-euryale-70b": { inputPerMtoken: 0.65, outputPerMtoken: 0.75 },
    "laguna-s-2.1": { inputPerMtoken: 0.09, outputPerMtoken: 0.18 },
    "laguna-s-2.1:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "laguna-xs-2.1": { inputPerMtoken: 0.06, outputPerMtoken: 0.12 },
    "laguna-xs-2.1:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "lfm-2.5-2.6b:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "lfm-2.5-24b-a2b": { inputPerMtoken: 0.05, outputPerMtoken: 0.7 },
    "ling-3.0-flash": { inputPerMtoken: 0.021, outputPerMtoken: 0.063 },
    "ling-3.0-flash-vl": { inputPerMtoken: 0.06, outputPerMtoken: 0.18 },
    "ling-3.1-flash": { inputPerMtoken: 0.075, outputPerMtoken: 0.225 },
    "llama-3.1-70b-instruct": { inputPerMtoken: 0.4, outputPerMtoken: 0.4 },
    "llama-3.1-8b-instruct": { inputPerMtoken: 0.05, outputPerMtoken: 0.08 },
    "llama-3.2-1b-instruct": { inputPerMtoken: 0.027, outputPerMtoken: 0.201 },
    "llama-3.2-3b-instruct": { inputPerMtoken: 0.05, outputPerMtoken: 0.33 },
    "llama-3.3-70b-instruct": { inputPerMtoken: 0.59, outputPerMtoken: 0.79 },
    "llama-4-maverick": { inputPerMtoken: 0.1875, outputPerMtoken: 0.6525 },
    "llama-4-scout": { inputPerMtoken: 0.18, outputPerMtoken: 0.59 },
    "llama-guard-4-12b": { inputPerMtoken: 0.18, outputPerMtoken: 0.18 },
    "longcat-2.0": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "lyria-3-clip-preview": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "lyria-3-pro-preview": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "magnum-v4-72b": { inputPerMtoken: 2.5, outputPerMtoken: 5 },
    "mercury-2": { inputPerMtoken: 0.25, outputPerMtoken: 0.75 },
    "mercury-2.5": { inputPerMtoken: 0.04, outputPerMtoken: 0.15 },
    "mimo-v2.5": { inputPerMtoken: 0.14, outputPerMtoken: 0.28 },
    "mimo-v2.5-pro": { inputPerMtoken: 0.435, outputPerMtoken: 0.87 },
    "mimo-v2.6-flash": { inputPerMtoken: 0.14, outputPerMtoken: 0.28 },
    "mimo-v2.6-pro": { inputPerMtoken: 0.435, outputPerMtoken: 0.87 },
    "mimo-v2.6-pro-ultraspeed": { inputPerMtoken: 4.35, outputPerMtoken: 8.7 },
    "minimax-01": { inputPerMtoken: 0.2, outputPerMtoken: 1.1 },
    "minimax-m1": { inputPerMtoken: 0.55, outputPerMtoken: 2.2 },
    "minimax-m2": { inputPerMtoken: 0.255, outputPerMtoken: 1.02 },
    "minimax-m2-her": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "minimax-m2.1": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "minimax-m2.5": { inputPerMtoken: 0.27, outputPerMtoken: 1.08 },
    "minimax-m2.7": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "minimax-m3": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "ministral-14b-2512": { inputPerMtoken: 0.2, outputPerMtoken: 0.2 },
    "ministral-3b-2512": { inputPerMtoken: 0.1, outputPerMtoken: 0.1 },
    "ministral-8b-2512": { inputPerMtoken: 0.15, outputPerMtoken: 0.15 },
    "mistral-large": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "mistral-large-2407": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "mistral-large-2512": { inputPerMtoken: 0.5, outputPerMtoken: 1.5 },
    "mistral-large-4-0": { inputPerMtoken: 0.68, outputPerMtoken: 2.09 },
    "mistral-medium-3": { inputPerMtoken: 0.4, outputPerMtoken: 2 },
    "mistral-medium-3-5": { inputPerMtoken: 1.5, outputPerMtoken: 7.5 },
    "mistral-medium-3.1": { inputPerMtoken: 0.4, outputPerMtoken: 2 },
    "mistral-nemo": { inputPerMtoken: 0.029, outputPerMtoken: 0.03 },
    "mistral-saba": { inputPerMtoken: 0.2, outputPerMtoken: 0.6 },
    "mistral-small-24b-instruct-2501": { inputPerMtoken: 0.05, outputPerMtoken: 0.08 },
    "mistral-small-2603": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "mistral-small-3.1-24b-instruct": { inputPerMtoken: 0.351, outputPerMtoken: 0.555 },
    "mistral-small-3.2-24b-instruct": { inputPerMtoken: 0.09375, outputPerMtoken: 0.25 },
    "mixtral-8x22b-instruct": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "morph-v3-fast": { inputPerMtoken: 0.8, outputPerMtoken: 1.2 },
    "morph-v3-large": { inputPerMtoken: 0.9, outputPerMtoken: 1.9 },
    "muse-glimmer-30b": { inputPerMtoken: 0.3, outputPerMtoken: 1.2 },
    "muse-spark-1.1": { inputPerMtoken: 1.25, outputPerMtoken: 4.25 },
    "muse-spark-1.2": { inputPerMtoken: 1.25, outputPerMtoken: 4.25 },
    "muse-spark-1.2-contributor": { inputPerMtoken: 0.1, outputPerMtoken: 0.2 },
    "muse-spark-1.3": { inputPerMtoken: 1.25, outputPerMtoken: 4.25 },
    "muse-spark-1.3-contributor": { inputPerMtoken: 0.1, outputPerMtoken: 0.2 },
    "muse-wonder": { inputPerMtoken: 4, outputPerMtoken: 20 },
    "mythomax-l2-13b": { inputPerMtoken: 0.08, outputPerMtoken: 0.11 },
    "nemotron-3-nano-30b-a3b": { inputPerMtoken: 0.06, outputPerMtoken: 0.24 },
    "nemotron-3-nano-omni-30b-a3b-reasoning:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nemotron-3-super-120b-a12b": { inputPerMtoken: 0.08, outputPerMtoken: 0.45 },
    "nemotron-3-super-120b-a12b:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nemotron-3-ultra-550b-a55b": { inputPerMtoken: 0.6, outputPerMtoken: 2.4 },
    "nemotron-3-ultra-550b-a55b:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nemotron-3.5-content-safety": { inputPerMtoken: 0.2, outputPerMtoken: 0.2 },
    "nemotron-3.5-content-safety:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nemotron-3.5-lightning": { inputPerMtoken: 0.07, outputPerMtoken: 0.2 },
    "nemotron-3.5-lightning:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nex-n2.5-mini": { inputPerMtoken: 0.025, outputPerMtoken: 0.1 },
    "nex-n2.5-pro": { inputPerMtoken: 0.075, outputPerMtoken: 0.25 },
    "north-mini-code:free": { inputPerMtoken: 0, outputPerMtoken: 0 },
    "nova-2-lite-v1": { inputPerMtoken: 0.3, outputPerMtoken: 2.5 },
    "nova-lite-v1": { inputPerMtoken: 0.06, outputPerMtoken: 0.24 },
    "nova-micro-v1": { inputPerMtoken: 0.035, outputPerMtoken: 0.14 },
    "nova-premier-v1": { inputPerMtoken: 2.5, outputPerMtoken: 12.5 },
    "nova-pro-v1": { inputPerMtoken: 0.8, outputPerMtoken: 3.2 },
    "o1": { inputPerMtoken: 15, outputPerMtoken: 60 },
    "o1-pro": { inputPerMtoken: 150, outputPerMtoken: 600 },
    "o3": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "o3-mini": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o3-mini-high": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o3-pro": { inputPerMtoken: 20, outputPerMtoken: 80 },
    "o4-mini": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "o4-mini-high": { inputPerMtoken: 1.1, outputPerMtoken: 4.4 },
    "palmyra-x5": { inputPerMtoken: 0.6, outputPerMtoken: 6 },
    "pareto-26.10-preview": { inputPerMtoken: 0.8, outputPerMtoken: 3.2 },
    "pareto-26.9": { inputPerMtoken: 2.5, outputPerMtoken: 7.5 },
    "pareto-latest": { inputPerMtoken: 2.5, outputPerMtoken: 7.5 },
    "perceptron-mk1": { inputPerMtoken: 0.15, outputPerMtoken: 1.5 },
    "perceptron-mk1.5": { inputPerMtoken: 0.15, outputPerMtoken: 1.5 },
    "phi-4": { inputPerMtoken: 0.07, outputPerMtoken: 0.14 },
    "qwen-2.5-72b-instruct": { inputPerMtoken: 0.36, outputPerMtoken: 0.4 },
    "qwen-2.5-7b-instruct": { inputPerMtoken: 0.1, outputPerMtoken: 0.2 },
    "qwen-2.5-coder-32b-instruct": { inputPerMtoken: 0.66, outputPerMtoken: 1 },
    "qwen-plus": { inputPerMtoken: 0.26, outputPerMtoken: 0.78 },
    "qwen2.5-vl-72b-instruct": { inputPerMtoken: 0.8, outputPerMtoken: 1 },
    "qwen3-14b": { inputPerMtoken: 0.12, outputPerMtoken: 0.24 },
    "qwen3-235b-a22b-2507": { inputPerMtoken: 0.09, outputPerMtoken: 0.55 },
    "qwen3-235b-a22b-thinking-2507": { inputPerMtoken: 0.45, outputPerMtoken: 3.5 },
    "qwen3-30b-a3b": { inputPerMtoken: 0.12, outputPerMtoken: 0.5 },
    "qwen3-30b-a3b-instruct-2507": { inputPerMtoken: 0.1, outputPerMtoken: 0.3 },
    "qwen3-32b": { inputPerMtoken: 0.08, outputPerMtoken: 0.28 },
    "qwen3-coder": { inputPerMtoken: 0.3, outputPerMtoken: 1 },
    "qwen3-coder-30b-a3b-instruct": { inputPerMtoken: 0.07, outputPerMtoken: 0.28 },
    "qwen3-coder-flash": { inputPerMtoken: 0.195, outputPerMtoken: 0.975 },
    "qwen3-coder-next": { inputPerMtoken: 0.12, outputPerMtoken: 0.8 },
    "qwen3-next-80b-a3b-instruct": { inputPerMtoken: 0.1, outputPerMtoken: 1.1 },
    "qwen3-next-80b-a3b-thinking": { inputPerMtoken: 0.15, outputPerMtoken: 1.2 },
    "qwen3-vl-235b-a22b-instruct": { inputPerMtoken: 0.21, outputPerMtoken: 1.9 },
    "qwen3-vl-30b-a3b-instruct": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "qwen3-vl-30b-a3b-thinking": { inputPerMtoken: 0.29, outputPerMtoken: 1 },
    "qwen3-vl-8b-instruct": { inputPerMtoken: 0.25, outputPerMtoken: 0.75 },
    "qwen3.5-122b-a10b": { inputPerMtoken: 0.26, outputPerMtoken: 2.08 },
    "qwen3.5-27b": { inputPerMtoken: 0.26, outputPerMtoken: 2.6 },
    "qwen3.5-35b-a3b": { inputPerMtoken: 0.15, outputPerMtoken: 1 },
    "qwen3.5-397b-a17b": { inputPerMtoken: 0.5, outputPerMtoken: 3.6 },
    "qwen3.5-9b": { inputPerMtoken: 0.1, outputPerMtoken: 0.15 },
    "qwen3.5-flash-02-23": { inputPerMtoken: 0.065, outputPerMtoken: 0.26 },
    "qwen3.5-plus-02-15": { inputPerMtoken: 0.26, outputPerMtoken: 1.56 },
    "qwen3.5-plus-20260420": { inputPerMtoken: 0.3, outputPerMtoken: 1.8 },
    "qwen3.6-27b": { inputPerMtoken: 0.32, outputPerMtoken: 3.2 },
    "qwen3.6-35b-a3b": { inputPerMtoken: 0.1, outputPerMtoken: 0.95 },
    "qwen3.6-flash": { inputPerMtoken: 0.1875, outputPerMtoken: 1.125 },
    "qwen3.6-plus": { inputPerMtoken: 0.325, outputPerMtoken: 1.95 },
    "qwen3.7-flash": { inputPerMtoken: 0.03, outputPerMtoken: 0.13 },
    "qwen3.7-max": { inputPerMtoken: 1.475, outputPerMtoken: 4.425 },
    "qwen3.7-plus": { inputPerMtoken: 0.32, outputPerMtoken: 1.28 },
    "qwen3.8-2.4t-a95b": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "qwen3.8-27b": { inputPerMtoken: 0.04, outputPerMtoken: 2.3 },
    "qwen3.8-flash": { inputPerMtoken: 0.15, outputPerMtoken: 0.47 },
    "qwen3.8-max-0902": { inputPerMtoken: 2, outputPerMtoken: 6 },
    "qwen3.8-max-prime": { inputPerMtoken: 4, outputPerMtoken: 12 },
    "qwen3.8-omni-flash": { inputPerMtoken: 0.15, outputPerMtoken: 0.47 },
    "reka-edge": { inputPerMtoken: 0.1, outputPerMtoken: 0.1 },
    "reka-flash-3": { inputPerMtoken: 0.1, outputPerMtoken: 0.2 },
    "relace-apply-3": { inputPerMtoken: 0.85, outputPerMtoken: 1.25 },
    "relace-search": { inputPerMtoken: 1, outputPerMtoken: 3 },
    "remm-slerp-l2-13b": { inputPerMtoken: 0.35, outputPerMtoken: 0.65 },
    "sakana-namazu": { inputPerMtoken: 0.95, outputPerMtoken: 4 },
    "schematron-v2-small": { inputPerMtoken: 0.05, outputPerMtoken: 0.23 },
    "schematron-v2-turbo": { inputPerMtoken: 0.03, outputPerMtoken: 0.15 },
    "seed-1.6": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "seed-1.6-flash": { inputPerMtoken: 0.075, outputPerMtoken: 0.3 },
    "seed-2-1-turbo": { inputPerMtoken: 0.5, outputPerMtoken: 2.5 },
    "seed-2.0-code": { inputPerMtoken: 0.5, outputPerMtoken: 3 },
    "seed-2.0-lite": { inputPerMtoken: 0.25, outputPerMtoken: 2 },
    "seed-2.0-mini": { inputPerMtoken: 0.1, outputPerMtoken: 0.4 },
    "skyfall-36b-v2": { inputPerMtoken: 0.55, outputPerMtoken: 0.8 },
    "solar-mini4": { inputPerMtoken: 0.05, outputPerMtoken: 0.2 },
    "solar-pro-3": { inputPerMtoken: 0.15, outputPerMtoken: 0.6 },
    "solar-pro4": { inputPerMtoken: 0.09, outputPerMtoken: 0.36 },
    "sonar": { inputPerMtoken: 1, outputPerMtoken: 1 },
    "sonar-deep-research": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "sonar-pro": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "sonar-pro-search": { inputPerMtoken: 3, outputPerMtoken: 15 },
    "sonar-reasoning-pro": { inputPerMtoken: 2, outputPerMtoken: 8 },
    "step-3.5-flash": { inputPerMtoken: 0.1, outputPerMtoken: 0.3 },
    "step-3.7-flash": { inputPerMtoken: 0.2, outputPerMtoken: 1.15 },
    "step-5-preview": { inputPerMtoken: 1, outputPerMtoken: 2.7 },
    "summarize": { inputPerMtoken: 0.04, outputPerMtoken: 0 },
    "ternary-bonsai-2-27b": { inputPerMtoken: 0.075, outputPerMtoken: 0.5 },
    "trinity-large-thinking": { inputPerMtoken: 0.25, outputPerMtoken: 0.8 },
    "ui-tars-1.5-7b": { inputPerMtoken: 0.1, outputPerMtoken: 0.2 },
    "unslopnemo-12b": { inputPerMtoken: 0.4, outputPerMtoken: 0.4 },
    "voxtral-small-24b-2507": { inputPerMtoken: 0.1, outputPerMtoken: 0.3 },
    "weaver": { inputPerMtoken: 0.4, outputPerMtoken: 0.75 },
    "wizardlm-2-8x22b": { inputPerMtoken: 0.62, outputPerMtoken: 0.62 },
  },
};
